import React from 'react'

import SvgIcon, { SvgIconProps } from '@material-ui/core/SvgIcon'

interface Props extends SvgIconProps {
  filled?: boolean
}

const path =
  'M10.5 0C4.706 0 0 4.706 0 10.5 0 16.292 4.706 21 10.5 21 16.292 21 21 16.292 21 10.5 21 4.706 ' +
  '16.292 0 10.5 0zm0 .955c.902 0 1.775.131 2.603.365l-2.64 2.028-2.886-1.931A9.553 9.553 0 0 1 1' +
  '0.5.955zm3.684.738a9.576 9.576 0 0 1 3.244 2.237L16.392 8.07l-2.424.813-2.998-2.178-.007-2.528' +
  ' 3.221-2.483zm-7.689.142l3.513 2.356.007 2.528-1.484 1.074-1.543 1.126-2.558-.775-1.037-4.02a9' +
  '.552 9.552 0 0 1 3.102-2.29zm11.686 2.997a9.506 9.506 0 0 1 1.842 5.049l-2.677-1.67.835-3.379z' +
  'm-15.534.231l.85 3.267-2.535 1.909c.052-1.92.663-3.7 1.685-5.176zM10.5 7.547l1.402 1.021 1.41 ' +
  '1.022-.538 1.656-.536 1.648H8.763l-.545-1.648-.537-1.656L10.5 7.547zm6.234 1.417l3.296 2.043a9' +
  '.51 9.51 0 0 1-1.185 4.124l-4.199.06-1.529-1.917.567-1.738.567-1.745 2.483-.827zm-12.602.09l2.' +
  '632.804.552 1.678.56 1.723-1.463 1.976-4.295-.149a9.518 9.518 0 0 1-1.126-3.684l3.14-2.349zm4.' +
  '489 4.794h3.728l1.537 1.924-1.238 4.027a9.589 9.589 0 0 1-4.34-.007l-1.141-3.975 1.454-1.969zm' +
  '-5.892 2.208l3.55.126.94 3.29a9.55 9.55 0 0 1-4.49-3.416zm15.504.037a9.563 9.563 0 0 1-4.482 3' +
  '.393l1.022-3.348 3.46-.045z'

const AvatarIcon: React.SFC<Props> = ({ filled, ...props }) => (
  <SvgIcon {...props} viewBox="0 0 22 22">
    <path d={path} />
  </SvgIcon>
)

export default AvatarIcon
